import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 24px;
  width: 100%;
`;

export const RefundableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.h2`
  font-family: "Rethink-Sans-Bold", "sans-serif";
  font-size: 16px;
  color: #ffffff;
  margin: 0;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const Divider = styled.div`
  background: #353535;
  height: 1px;
  width: 100%;
`;

export const RefundableAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AmountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AmountLabel = styled.span`
  font-family: "Rethink-Sans-SemiBold", "sans-serif";
  font-size: 14px;
  color: #ffffff;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const AmountSubLabel = styled.span`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 10px;
  color: #a7a7a7;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const AmountValue = styled.span`
  font-family: "Rethink-Sans-SemiBold", "sans-serif";
  font-size: 14px;
  color: #03c095;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const AmountSubValue = styled.span`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 10px;
  color: #a7a7a7;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 14px;
  color: #ffffff;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const OptionalLabel = styled.span`
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-size: 11px;
  color: #d5d5d5;
  margin-left: 8px;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropdownButton = styled.button`
  background: #2c2c2c;
  border: 2px solid #353535;
  border-radius: 8px;
  width: 100%;
  height: 50px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-size: 16px;
  color: #ffffff;
  text-align: left;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const DropdownOptions = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #2c2c2c;
  border: 2px solid #353535;
  border-radius: 8px;
  margin-top: 4px;
  padding: 8px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  z-index: 10;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

export const DropdownOption = styled.div`
  background: #464646;
  border-radius: 8px;
  padding: 8px 16px;
  margin-bottom: 4px;
  cursor: pointer;
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 14px;
  color: #ffffff;
  height: 44px;
  display: flex;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background: #525252;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const Input = styled.input`
  background: #2c2c2c;
  border: 2px solid #353535;
  border-radius: 8px;
  width: 100%;
  height: 50px;
  padding: 0 16px;
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-size: 16px;
  color: #ffffff;
  outline: none;

  &::placeholder {
    color: #ffffff;
    opacity: 0.5;
  }

  &:focus {
    border-color: #f3b900;
  }

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const TextArea = styled.textarea`
  background: #2c2c2c;
  border: 2px solid #353535;
  border-radius: 8px;
  width: 100%;
  height: 124px;
  padding: 16px;
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-size: 16px;
  color: #ffffff;
  outline: none;
  resize: none;

  &::placeholder {
    color: #ffffff;
    opacity: 0.5;
  }

  &:focus {
    border-color: #f3b900;
  }

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CheckboxIcon = styled.div`
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
`;

export const CheckboxLabel = styled.label`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const NoteText = styled.div`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 14px;
  color: #ffffff;
  opacity: 0.5;
  margin-left: 26px;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const SubmitButton = styled.button<{ disabled: boolean }>`
  background: ${(props) => (props.disabled ? "#fbc94b" : "#f3b900")};
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  color: #000000;
  font-family: "Rethink-Sans-SemiBold", "sans-serif";
  font-size: 16px;
  border: none;
  border-radius: 9999px;
  height: 51px;
  width: 100%;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: opacity 0.2s;

  &:hover {
    opacity: ${(props) => (props.disabled ? "0.5" : "0.9")};
  }

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #2c2c2c;
  border: 1px solid #353535;
  border-radius: 24px;
  padding: 36px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  font-family: "Rethink-Sans-Bold", "sans-serif";
  font-size: 20px;
  color: #ffffff;
  margin: 0;
  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const ModalDescription = styled.p`
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-size: 16px;
  color: #ffffff;
  margin: 0;
  line-height: 22px;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const ModalButton = styled.button`
  background: #fbc94b;
  color: #000000;
  font-family: "Rethink-Sans-SemiBold", "sans-serif";
  font-size: 15px;
  border: none;
  border-radius: 9999px;
  height: 53px;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;
